module.exports = __webpack_public_path__ + "0a236b051ac7689e629b76ddf6c306e8.pdf";